import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ palette, custom, breakpoints }: Theme) => ({
    root: {
      zIndex: 0,
      '& main': {
        paddingTop: 0,
      },
    },
    qa: {
      maxWidth: 600,
      [breakpoints.down(1024)]: {
        margin: '0 auto',
      },
    },
    section: {
      paddingTop: 40,
    },
    sectionGrey: {
      '& $sectionHeader': {
        fontFamily: 'Merriweather',
        fontSize: 22,
        fontWeight: 900,
      },
      '& $paragraph': {
        lineHeight: '22px',
      },
    },
    sectionWarranty: {
      '& $sectionWrapper': {
        display: 'block',
      },
    },
    sectionWrapper: {
      maxWidth: 1200,
      margin: '0 auto',
    },
    sectionHeader: {
      margin: 0,
      marginBottom: 20,
      color: custom.grey[3],
      fontSize: 18,
      fontWeight: 600,
    },
    sectionHeaderWithIcon: {
      color: palette.primary.main,
      marginBottom: 40,
      fontSize: 18,
      fontWeight: 600,
      flexBasis: '100%',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 15,
        width: 24,
        height: 24,
      },
    },
    paragraph: {
      fontSize: 14,
      lineHeight: 1.43,
      color: custom.grey[3],
      margin: 0,
    },
    list: {
      fontSize: 14,
      paddingLeft: 20,
      lineHeight: 1.43,
      color: custom.grey[3],
    },
    listInText: {
      marginBottom: 0,
    },
    listItem: {
      marginTop: 20,
      '&::marker': {
        fontWeight: 'bold',
      },
    },
    warrantyInfo: {
      fontSize: 18,
      fontWeight: 'bold',
      marginBottom: 15,
      color: custom.grey[3],
    },
    warrantyImage: {
      height: 40,
      marginRight: 30,
    },
    descriptionBox: {
      borderTop: `1px solid ${custom.grey[1]}`,
      padding: '20px 0',
    },
    up: {
      marginTop: 40,
      fontSize: 16,
      lineHeight: '22px',
      width: 181,
      height: 52,
      [breakpoints.down(769)]: {
        width: '100%',
      },
    },
    fullWidth: {
      marginRight: 'calc(-395px - max(calc(100vw - 1060px), 0px))',
      maxWidth: 1160,
      [breakpoints.down(1024)]: {
        maxWidth: '100%',
      },
    },
  })
);
